import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createTicketInfoReportSlice = (set, get) => ({
    crmTicketInfoReport: {
        loading: false,
        data: []
    },
    getCrmTicketInfoReport: async (ID) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmTicketInfoReport: { ...state.crmTicketInfoReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/crm/ticket/${ID}/info`,
                headers: { token }
            });
            set(state => ({ crmTicketInfoReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmTicketInfoReport: { ...state.crmTicketInfoReport, loading: false } }));
        }
    }
});
